module.exports = __webpack_public_path__ + "img/CharlieS.6bbf2dac.png";